import React from 'react';

const MarketSpendTotals = ({ marketSpendTotals }) => {
  return (
    <div className="px-3 market-spend-totals">
      <div className="d-flex flex-row gap-2 align-items-center">
        {/* Chevron */}
        <div>
          <div className="market-spend-totals-chevron-placeholder" />
        </div>

        <div className="d-inline-flex align-items-center r-container gap-2 w-100">
          <div className="d-inline-flex gap-2 w-100">
            <div
              className="d-inline-flex align-items-center"
              style={{ width: '30%' }}
            ></div>
            <div className="d-inline-flex align-items-center market-spend-totals-column"></div>
            <div className="d-inline-flex justify-content-center market-spend-totals-column">
              <div className="w-100 px-2 market-spend-totals-text">
                {marketSpendTotals.totalAllocation || 0}%
              </div>
            </div>
            <div className="d-inline-flex justify-content-center market-spend-totals-column">
              <div className="w-100 px-2 market-spend-totals-text">
                {marketSpendTotals.totalBudget}
              </div>
            </div>
            <div className="d-inline-flex justify-content-center market-spend-totals-column"></div>
            <div className="d-inline-flex justify-content-center market-spend-totals-column"></div>
            <div className="d-inline-flex justify-content-center market-spend-totals-column"></div>
            <div className="d-inline-flex justify-content-center market-spend-totals-column"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketSpendTotals;
